import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { IonicStorageModule } from '@ionic/storage';
import { HttpClientModule } from '@angular/common/http';
import { BASE_PATH, ApiModule } from 'ticket-sdk';
import { environment } from '@env';
import { PagesModule } from './pages/pages.module';
import { CoreModule } from './core/core.module';
import { ReactiveFormsModule } from '@angular/forms';
import { ServiceWorkerModule } from '@angular/service-worker';
import { registerLocaleData } from '@angular/common';
import localeSv from '@angular/common/locales/sv';
import { RitGrpBankidFrejaAuthModule } from '@rit/ngx-bankid-freja-auth';
registerLocaleData(localeSv);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    IonicStorageModule.forRoot(),
    ApiModule,
    HttpClientModule,
    PagesModule,
    CoreModule,
    ReactiveFormsModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    RitGrpBankidFrejaAuthModule,
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: BASE_PATH, useValue: environment.ticketServerUrl },
    { provide: LOCALE_ID, useValue: "sv-SE" }
    // BankIdService,
    // UserService,
    // TicketPriceService,
    // Deeplinks,
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
